<template>
  <div class="aboutUs">
    <div class="pao pao1 wow slideInLeftSelf"></div>
    <myMenu :type="2" @zoomChange="initWow"></myMenu>
    <div class="aboutUs_content">
      <div class="linear_word">COOPERATION</div>
      <div class="linear_word2 slideInUp_p">
        <div class="wow slideInUp">招商合作</div>
      </div>
      <div class="main wow fadeIn" data-wow-delay="0.3s">
        <div class="word">这里不仅是欢乐的开始，更是成功篇章的开端！携手同行，共谱未来美好蓝图！</div>
        <div class="word icon"><strong>地址：</strong>浙江省宁波市前湾新区天宝路189号</div>
        <div class="word icon"><strong>招商电话：</strong>0574-58585788</div>
        <div class="qr_list">
          <div class="qr_item">
            <img src="@/assets/wb_qr.jpg">
            <div class="name">官方微博</div>
          </div>
          <div class="qr_item">
            <img src="@/assets/wx_qr.jpg">
            <div class="name">官方微信</div>
          </div>
        </div>
        <div class="word icon"><strong>方特旅游：</strong><span class="link" @click="$toPage('https://www.fangte.com/')">https://www.fangte.com/</span></div>
      </div>
    </div>
    <myBottom></myBottom>
  </div>
</template>

<script>
import myMenu from '@/components/myMenu.vue'
import myBottom from '@/components/myBottom.vue'

import "wowjs/css/libs/animate.css";
import "@/assets/css/wowExtra.css";
import { WOW } from 'wowjs'

export default {
  components: { myMenu, myBottom },
  data() {
    return {

    }
  },
  methods: {
    setWow() {
      $('.dec1, .pic1').css('transform', 'translate(-20000px, 0)');
    },
    initWow(zoom) {
      var top = $('.aboutUs .main').offset().top;
      var offset = zoom >= 1 ? 200 * zoom : (200 * zoom - (top - top * zoom));
      var wow = new WOW(
        {
          animateClass: 'animated',
          offset,
          callback: box => {
            if (box.className.includes('title1_span')) {
              $('.dec1, .pic1').css('transform', 'translate(0, 0)');
              $('.dec1').addClass('fadeInDown');
            }
            $(box).removeClass('wow');
          }
        }
      );
      wow.init();
    },
  },
  mounted() {
    this.setWow();
  }
}
</script>

<style lang="scss" scoped>
.aboutUs {
  .aboutUs_content {
    width: 1320px;
    margin: 110px auto 100px;
    position: relative;
    .main {
      border-radius: 20px;
      background-color: rgb(255, 255, 255);
      box-shadow: 0px 8px 54px 0px rgba(111, 159, 227, 0.3);
      min-height: 690px;
      padding: 100px 124px;
      margin-top: 50px;
    }
    .word {
      font-size: 26px;
      line-height: 50px;
      color: #1e1e1e;
      padding-left: 60px;
      position: relative;
      .link{
        cursor: pointer;
      }
    }
    .icon {
      &::before {
        content: '';
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #f39f43;
        vertical-align: middle;
        display: inline-block;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
    .qr_list {
      text-align: center;
      margin-top: 70px;
      padding-bottom: 160px;
    }
    .qr_item {
      display: inline-block;
      border-radius: 14px;
      background-color: rgb(243, 159, 67);
      padding: 14px;
      position: relative;
      margin: 0 135px;
      font-size: 0;
      img{
        width: 188px;
      }
      .name {
        font-size: 26px;
        color: #000;
        position: absolute;
        bottom: -70px;
        left: 0;
        width: 100%;
        text-align: center;
      }
    }
  }
  .pao1 {
    border-radius: 50%;
    background-image: -moz-linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    background-image: -webkit-linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    background-image: -ms-linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    background-image: linear-gradient(
      -20deg,
      rgb(66, 128, 253) 0%,
      rgb(149, 219, 255) 100%
    );
    opacity: 0.6;
    left: -110px;
    top: 785px;
    width: 239px;
    height: 239px;
  }
}
</style>